import Vue from 'vue'
import VueSession from 'vue-session'

Vue.use(VueSession)



// WEBPACK FOOTER //
// ./src/session/index.js